import { markRaw, type Component } from 'vue'
import { useI18n } from 'vue-i18n'
import { useModal, type ModalResult } from '@/apps/core'

/**
 * Opens the organization's invitation modal: one or more addresses, one role, one invitation
 * each. Must be called at the top of a setup function. Resolves when the modal closes, with
 * `confirmed` set only when every address was invited.
 */
export function useOrgInviteModal() {
  const { open } = useModal()
  const { t } = useI18n()

  async function openOrgInviteModal(): Promise<ModalResult> {
    const { default: OrgInviteModal } = await import('../modals/OrgInviteModal.vue')
    return open(t('settings.invite.title'), markRaw(OrgInviteModal as Component), {
      width: '520px',
      scrollable: true,
      hideHeader: true,
    })
  }

  return { openOrgInviteModal }
}
